module.exports = __webpack_public_path__ + "static/img/2s-info-b4.0cd43a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/2s-info-b4.jpg
// module id = rO48
// module chunks = 0